import { useQuery } from '@tanstack/react-query';
import { getCollectionAttemptsToday } from '@/services/credit-worker.service';

const REFETCH_INTERVAL = 30_000;

/**
 * Trae los intentos de cobro automatizado del dia con status (SUCCESS,
 * PARTIAL, FAILED, PENDING) para alimentar los KPIs "Cobrados hoy" /
 * "Por intentar hoy" / "Fallidos" en CobrosPage.
 */
export function useCollectionAttemptsToday(partnerId: string) {
  const query = useQuery({
    queryKey: ['collection', 'attempts', 'today', partnerId],
    queryFn: () => getCollectionAttemptsToday(partnerId),
    refetchInterval: REFETCH_INTERVAL,
    enabled: Boolean(partnerId),
  });

  return {
    attempts: query.data?.data?.attempts ?? [],
    summary: query.data?.data?.summary ?? null,
    date: query.data?.data?.date ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => query.refetch(),
  };
}
